"use client"
import React, { useState } from "react"
import "bootstrap/dist/css/bootstrap.min.css"
import "./ContactUs.css"
import img from '../../assets/LC.jpg'
export default function ContactUs() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    countryCode: "+91",
    phone: "",
    message: "",
  })
  const [errors, setErrors] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [submitStatus, setSubmitStatus] = useState(null)

  const validateForm = () => {
    const newErrors = {}

    if (!formData.firstName.trim()) newErrors.firstName = "First name is required"
    if (!formData.lastName.trim()) newErrors.lastName = "Last name is required"
    if (!formData.email.trim()) {
      newErrors.email = "Email is required"
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid"
    }
    if (!formData.phone.trim()) newErrors.phone = "Phone number is required"
    if (!formData.message.trim()) newErrors.message = "Message is required"

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const formatPhoneNumber = (value) => {
    // Basic phone number formatting (remove non-digits and limit length)
    return value.replace(/\D/g, '').slice(0, 15)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!validateForm()) return

    setIsLoading(true)
    setSubmitStatus(null)

    try {
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1500))
      console.log("Form submitted:", formData)
      setSubmitStatus('success')

      // Reset form on success
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        countryCode: "+62",
        phone: "",
        message: "",
      })
    } catch (error) {
      setSubmitStatus('error')
      console.error("Submission failed:", error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target

    setFormData({
      ...formData,
      [name]: name === 'phone' ? formatPhoneNumber(value) : value,
    })

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors({ ...errors, [name]: '' })
    }
  }
  // Location badge component (inline for simplicity)
  const LocationBadgeLink = () => (
    <a
      href="https://share.google/G7d7WXCRaQOImO4Jp"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Open location on Google Maps"
      style={{ textDecoration: "none", display: "inline-block" }}
    >
      <span
        className="badge bg-primary rounded-circle p-3"
        role="img"
        aria-label="Location badge"
        style={{ display: "inline-flex", alignItems: "center", justifyContent: "center" }}
      >
        <svg width="24" height="24" fill="white" viewBox="0 0 24 24" aria-label="location icon" focusable="false">
          <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
        </svg>
      </span>
    </a>
  );

  const handleEmailSent = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setIsLoading(true);
    setSubmitStatus(null);

    try {
      const response = await fetch('http://localhost:5000/api/contact/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (data.success) {
        setSubmitStatus('success');
        // Reset form on success
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          countryCode: "+91",
          phone: "",
          message: "",
        });
      } else {
        // Show server-side validation errors
        setErrors(data.errors || { general: data.message });
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
      console.error("Submission failed:", error);
    } finally {
      setIsLoading(false);
    }
  };



  return (
    <>
      {/* Contact Section */}
      <div className="contact-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="contact-card">
                <h1 className="contact-heading">Contact Us</h1>
                <p className="contact-subtitle">
                  Email, call, or complete the form to learn how we can solve your messaging problem.
                </p>
                <div className="contact-info">
                  <p><a href="Connect@blukraft.com">Connect@blukraft.com</a></p>
                  <p><a href="tel:+91 321-221-231">+91 321-221-231</a></p>
                </div>
                <div className="row support-columns">
                  <div className="col-md-4 support-column">
                    <h5>Customer Support</h5>
                    <p>Our support team is available around the clock to address any concerns or queries you may have.</p>
                  </div>
                  <div className="col-md-4 support-column">
                    <h5>Feedback and Suggestions</h5>
                    <p>We value your feedback and are continuously working to improve. Your input is crucial in shaping the future of blukraft.</p>
                  </div>
                  <div className="col-md-4 support-column">
                    <h5>Media Inquiries</h5>
                    <p>For media-related questions or press inquiries, please contact us at <a href="mailto:Connect@blukraft.com">Connect@blukraft.com</a>.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="form-card">
                <h2 className="h4 mb-1">Get in Touch</h2>
                <p className="text-muted mb-4">You can reach us anytime</p>

                {submitStatus === 'success' && (
                  <div className="alert alert-success alert-dismissible fade show" role="alert">
                    Thank you! Your message has been sent successfully. We'll get back to you soon.
                    <button type="button" className="btn-close" onClick={() => setSubmitStatus(null)}></button>
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="alert alert-danger alert-dismissible fade show" role="alert">
                    Something went wrong. Please try again.
                    <button type="button" className="btn-close" onClick={() => setSubmitStatus(null)}></button>
                  </div>
                )}

                <form onSubmit={handleEmailSent} noValidate aria-describedby={submitStatus ? "form-status" : undefined}>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <div className="form-floating">
                        <input
                          id="firstName"
                          type="text"
                          className={`form-control ${errors.firstName ? 'is-invalid' : ''}`}
                          placeholder="First name"
                          name="firstName"
                          value={formData.firstName}
                          onChange={handleChange}
                          aria-describedby="firstName-error"
                          required
                        />
                        <label htmlFor="firstName">First name</label>
                        {errors.firstName && (
                          <div id="firstName-error" className="invalid-feedback">
                            {errors.firstName}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating">
                        <input
                          id="lastName"
                          type="text"
                          className={`form-control ${errors.lastName ? 'is-invalid' : ''}`}
                          placeholder="Last name"
                          name="lastName"
                          value={formData.lastName}
                          onChange={handleChange}
                          aria-describedby="lastName-error"
                          required
                        />
                        <label htmlFor="lastName">Last name</label>
                        {errors.lastName && (
                          <div id="lastName-error" className="invalid-feedback">
                            {errors.lastName}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="mb-3">
                    <div className="form-floating">
                      <input
                        id="email"
                        type="email"
                        className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                        placeholder="Your email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        aria-describedby="email-error"
                        required
                      />
                      <label htmlFor="email">Your email</label>
                      {errors.email && (
                        <div id="email-error" className="invalid-feedback">
                          {errors.email}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="mb-3">
                    <label htmlFor="phone" className="form-label">Phone number</label>
                    <div className="input-group">
                      <select
                        id="countryCode"
                        className="form-select country-select"
                        name="countryCode"
                        value={formData.countryCode}
                        onChange={handleChange}
                        aria-label="Country code"
                      >
                        <option value="+91">+91</option>
                        <option value="+1">+1</option>
                        <option value="+44">+44</option>
                        <option value="+62">+62</option>
                        <option value="+61">+61</option>
                        <option value="+81">+81</option>
                      </select>
                      <input
                        id="phone"
                        type="tel"
                        className={`form-control ${errors.phone ? 'is-invalid' : ''}`}
                        placeholder="Phone number"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        aria-describedby="phone-error"
                        required
                      />
                      {errors.phone && (
                        <div id="phone-error" className="invalid-feedback">
                          {errors.phone}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="mb-3">
                    <div className="form-floating">
                      <textarea
                        id="message"
                        className={`form-control ${errors.message ? 'is-invalid' : ''}`}
                        rows={8}
                        placeholder="How can we help?"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        maxLength={500}
                        aria-describedby="message-error"
                        required
                      ></textarea>
                      <label htmlFor="message">How can we help?</label>
                      <div className="char-count mt-1">
                        {formData.message.length}/500
                      </div>
                      {errors.message && (
                        <div id="message-error" className="invalid-feedback d-block">
                          {errors.message}
                        </div>
                      )}
                    </div>
                  </div>

                  <button
                    type="submit"
                    className="btn btn-submit w-100"
                    disabled={isLoading}
                    aria-label={isLoading ? "Submitting..." : "Submit form"}
                  >
                    {isLoading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Sending...
                      </>
                    ) : (
                      'Submit'
                    )}
                  </button>

                  <p className="terms-text mt-3">
                    By contacting us, you agree to our <a href="#">Terms of service</a> and{" "}
                    <a href="#">Privacy Policy</a>
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Location Section */}
      <div className="map-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="map-container d-flex align-items-center justify-content-center" style={{ width: '100%', height: 260, border: '1px solid #ddd' }}>
                <div className="image-box" style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #ddd' }}>
                  <a href="https://share.google/fEwaMjH9RwID8nVe5" target="https://share.google/fEwaMjH9RwID8nVe5" rel="https://share.google/fEwaMjH9RwID8nVe5" aria-label="Open location">
                    <img src={img} alt="Location" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="location-details">
                <p className="location-label">Our Location</p>
                <h2 className="location-heading">Connecting Near and Far</h2>
                <div className="headquarters">
                  <h4>Head Quarters</h4>
                  <p>Blukraft Global Services Pvt Ltd</p>
                  <p>Summit Apartments,Office Number: 301, Hillfort Road</p>
                  <p>Khairatabad, Hyderabad - 500004</p>
                  <p>India</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
